/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit End/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function End({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/LoadMoreAction/Content/End"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="End.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-iKz': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="End of Messages"
/>
</div>
{children}
</React.Fragment>)
}